module.exports = __webpack_public_path__ + "28188776afddd7c6669e304b8ddd748f.jpg";